import Modal from 'react-modal'
import { Button } from '@mui/material'
import styles from './RelatedItemsModal.module.scss'
import { ReactComponent as OpenItemIcon } from 'icons/OpenItemIcon.svg'

export const RelatedItemsModal = ({
  isOpen,
  onRequestClose,
  title,
  items,
  onOpenItem,
  closeButtonLabel = 'Close'
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0,0,0, 0.5)',
          width: '100%',
          height: '100%',
          zIndex: 100000000000
        },
        content: {
          overflow: 'auto',
          background: 'none',
          padding: '2em',
          inset: 'auto',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '70%',
          minWidth: '400px',
          boxShadow: '0 0 5px grey',
          backgroundColor: 'rgba(255,255,255)',
          borderRadius: '32px',
          border: '1px solid grey',
          marginLeft: '24px',
          marginRight: '24px',
          position: 'relative',
          paddingBottom: '80px'
        }
      }}
    >
      <h4 className={styles.modalTitle}>{title}</h4>
      <div className={styles.modalHeight}>
        {items && items.length > 0 ? (
          items.map(project => (
            <button
              type='button'
              key={project.ProjectId}
              className={styles.itemRow}
              onClick={() => {
                onOpenItem(project)
                onRequestClose()
              }}
            >
              <p className={styles.itemName}>{project.Meta.name}</p>
              <span className={styles.openIconWrapper}>
                <OpenItemIcon className={styles.openIcon} />
              </span>
            </button>
          ))
        ) : (
          <p>No related items found.</p>
        )}
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          fullWidth
          variant='contained'
          className={styles.buttonCancelar}
          onClick={onRequestClose}
        >
          {closeButtonLabel}
        </Button>
      </div>
    </Modal>
  )
}
